import { DataModel } from 'legacy/lut/classes/models/DataModel'

import { IForm } from 'core-components/classes/models/IForm'

export const convertIFormToDataModel = (data: IForm[]) => data.map((i) => new DataModel(i))
